export default __webpack_public_path__ + "static/media/12.6284d95f.jpg";